













































import Vue from 'vue';
import { get } from 'lodash';

interface Field {
  name?: string;
  title?: string;
  key?: string;
  cssClass?: string;
  disableClick?: boolean;
}

export default Vue.extend({
  props: {
    fields: {
      type: Array as () => Array<Field>,
      default() {
        return [];
      },
    },
    items: {
      type: Array,
      default: null,
    },
  },
  data() {
    return {
      hoverIndex: null,
    };
  },
  computed: {
    tableData() {
      if (!this.items) return;

      const tableData = this.items.map(result => {
        return this.fields.map((field, fieldIndex) => {
          return {
            cssClass: field.cssClass || '',
            slotData: result,
            slotName: field.name || fieldIndex,
            text: field.key ? get(result, field.key) : null,
            disableClick: field.disableClick,
          };
        });
      });

      return tableData;
    },
    isNoData() {
      return this.tableData && !this.tableData.length;
    },
  },
  methods: {
    getCssClass(cellData) {
      const cssClass = cellData.cssClass?.split(' ') || '';
      if (cellData.disableClick) cssClass.push('disable-click');
      return cssClass.join(' ');
    },
    setHoverIndex(rowIndex, cellData) {
      if (!cellData.disableClick) {
        this.hoverIndex = rowIndex;
      }
    },
  },
});
